<template lang="html">
  <div class="paper-item" :class="{'paper-item-active': isActive && !paused}" @click="handlerClick">
    <div class="paper-item-main flexBox">
      <img v-if="isActive && !paused" src="../assets/icons/icon-paper-play.png" alt="">
      <img v-else src="../assets/icons/icon-paper-pause.png" alt="">
      <div class="paper-item-desc">
        <p class="paper-item-desc-title" :class="{'weight': isRadio}">{{paperInfo.title}}</p>
        <p style="color: #999999">
          <span v-if="!isRadio">{{paperInfo.happenTime | dateFilter}}更新</span>
          <span>{{paperInfo.happenTime | dateUtils}}</span>
          <span class="paper-item-desc-num">{{paperInfo.learnCount}}人已收听</span>
        </p>
      </div>
    </div>
    <div class="paper-item-time" :class="{'weight': isRadio}">
      <template v-if="isActive">{{currentTime | timeFilter}}/</template>{{paperInfo.duration | timeFilter}}
    </div>
  </div>
</template>

<script>
import { format_filter } from '../lib/dateUtils'
import formatSeconds from '../filters/format-seconds-2'

export default {
  data () {
    return {
    }
  },
  name: 'PaperItem',
  props: ['paperInfo', 'paperIndex', 'isActive', 'parentIndex', 'currentTime', 'paused', 'isRadio'],
  filters: {
    timeFilter: t => formatSeconds(t),
    dateFilter: t => format_filter(t)('HH:mm'),
    dateUtils (val) {
      let currentDay = format_filter(new Date())('YYYY-MM-DD')
      return currentDay === format_filter(val)('YYYY-MM-DD') ? '今天' : format_filter(val)('MM/DD')
    }
  },
  methods: {
    handlerClick () {
      if (this.isRadio) {
        this.$router.push({
          path: '/audio-detail',
          query: {
            ...this.$route.query,
            chapterId: this.paperInfo.id,
            courseId: this.$route.params.courseId
          }
        })
      }
      this.$emit('play', this.paperInfo, this.paperIndex, this.parentIndex)
    }
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.paper-item {
  line-height: 1.2;
  position: relative;
  padding: rem(30) 0;
  border-bottom: rem(2) solid #EBEBEB;
  .flexBox {
    display: flex;
    align-items: center;
    /*justify-content: space-between;*/
  }
  &-time {
    position: absolute;
    font-size: rem(30);
    /*font-weight: bold;*/
    right: 0;
    bottom: rem(30);
  }

  &-main {
    width: rem(600);
    > img {
      width: rem(48);
      height: rem(48);
      margin-right: rem(20);
    }
  }
  &-desc {
    &-title {
      font-size: rem(30);
      margin-bottom: rem(10);
      width: rem(540);
      white-space:nowrap;overflow:hidden;text-overflow:ellipsis;
    }
    &-num {
      margin-left: rem(30);
    }
  }
  &-active {
    color: #FF7A19;
    font-weight: bolder;
  }
}
</style>
